module.exports = __webpack_public_path__ + "img/how-works-modal-image-01.9e7b366.svg";